import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from './services/authentication.service';
import { IdleManagerService } from './services/idle-manager.service';
import { StorageService } from './services/storage.service';

@Injectable()
export class AuthGuard implements CanActivate {

  hasRole = true;

  constructor(private router: Router,
              private authentication: AuthenticationService,
              private storageService:StorageService
             ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let previuosUrl:any=window.location.pathname;
    if(localStorage.getItem('isLogged')!=undefined && localStorage.getItem('isLogged')=='true'){
      this.storageService.isLogged=true;
    }
    if (this.storageService.isLogged == true) {

      //this.RoleGuard(next.data.Roles);

      if (this.hasRole === true) {
        return true;
      } else {
        //this.router.navigate(['/user/unauthorised']);
        this.router.navigate(['/home']);
        return false;
      }
    }else{
      localStorage.setItem("previousUrl",previuosUrl);
      this.router.navigate(['/login']);
    }

    
  }

  RoleGuard(Roles: any) {

    const self = this;

    if (Roles) {
      this.authentication.userData.Roles.forEach(function(UserRole) {
        Roles.forEach(function(Role) {
            if (UserRole.Code === Role) {
              self.hasRole = true;
            }
        });
      });

    } else {
      self.hasRole = true;
    }

  }
}
